import * as c from '../../constants/unity';
import { ENG_INIT } from '../../constants/engineering';
import { LOAD_PREFERENCES, UNITY_MODE } from '../../constants/preferences';

export const defaultState = {
  initialized: false,
  loading: false,
  loadingProgress: 0,
  loadingMessage: '',
  scene: 0,
  visible: false,
  mode: c.UNITY_MODE_WEBGL,
  webglPath: '',
  error: undefined,
};

const unity = (state = defaultState, action) => {
  switch (action.type) {
    case ENG_INIT:
      const { webglFile } = action.data.engineering;
      if (state.webglPath === webglFile) {
        // Don't reload unless webglFile is different from before
        return state;
      }
      return {
        ...state,
        webglPath: webglFile,
        unityContextInitialized: false, // because webglFile changed (will trigger re-creating unity context)
      };
    case c.UNITY_CONTEXT_INITIALIZED:
      return {
        ...state,
        unityContextInitialized: action.unityContextInitialized,
      };
    case c.UNITY_SET_LOADING:
      return { ...state, loading: action.loading };
    case c.UNITY_SET_LOADING_PROGRESS:
      return {
        ...state,
        loadingProgress: action.progress,
        loadingMessage: action.message,
        loading: action.progress >= 1,
      };
    case c.UNITY_SET_INITIALIZED:
      return {
        ...state,
        initialized: !action.error,
        loading: false,
        loadingProgress: 1,
        error: action.error,
      };
    case c.UNITY_SET_MODE:
      return { ...state, mode: action.mode };
    case c.UNITY_SET_SCENE:
      return { ...state, scene: action.scene };
    case c.UNITY_SET_VISIBLE:
      return { ...state, visible: action.visible };
    case LOAD_PREFERENCES:
      if (
        action.preferences.hasOwnProperty(UNITY_MODE) &&
        c.VALID_UNITY_MODES.indexOf(action.preferences[UNITY_MODE]) >= 0
      ) {
        return { ...state, mode: action.preferences[UNITY_MODE] };
      } else {
        return state;
      }
    default:
      return state;
  }
};

export default unity;
